import React from 'react';
import ReactDOM from 'react-dom';
import { Redirect, Link } from 'react-router-dom';

import { ajax } from './globals';
import { Languages } from './languages';
import App from '../App';
import { InputBox, MessageBox, UButton, ErrorMessageBox, LoaderBox } from './utilities';
import { PageTitle, ScrollableGrid, ScrollableGridItem, UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox } from '../components/guiElements';
import { AuthContext } from "../auth/authContext"
import { saveUserContext } from "../auth/sessionService"

export default class Login extends React.Component {
    static contextType = AuthContext;
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            modalMessage: ''
        };
        this.dataChange = this.dataChange.bind(this);
        this.loginClick = this.loginClick.bind(this);
        this.keyUp = this.keyUp.bind(this);
    }

    dataChange(ev) {
        let data = ev.target.name;
        let value = ev.target.value;
        let curState = JSON.parse(JSON.stringify(this.state));
        curState[data] = value;
        this.setState(curState);
    }

    loginClick(ev) {
        this.setState({ modalMessage: '', loading: true });
        ajax(this, { method: 'post', url: '/api/user/login', data: { Username: this.state.email, Password: this.state.password } },
            response => {
                //sessionStorage.setItem("userContext", JSON.stringify(response.data));
                //console.log("context: ", this.context);
                const sessionSaved = saveUserContext(response.data);

                if (!sessionSaved) {
                    this.setState({
                        modalMessage: "La sessione ricevuta non è valida.",
                        loading: false
                    });
                    return;
                }
                this.context.refreshAuthorization();
                this.props.onLogin();
            },
            error => {
                if(!error.success && error.errorMessage) {
                    this.setState({ modalMessage: error.errorMessage, loading: false });    
                } else {
                    this.setState({ modalMessage: error, loading: false });
                }
                
            }
        );
    }


    keyUp(ev) {
        if (ev.key === 'Enter') this.loginClick(ev);
    }

    render() {
        const le = Languages.Login[Languages.selectedLanguage];

        return <div className="full-panel">
            <div className="page-login">
                <div className={"widget " + (this.state.loading ? "disabled" : "")}>
                    <div className="widget-header">
                        <div className="login-header-logo" />
                    </div>
                    <div className="widget-content">
                        <div className="widget-content-title">
                            {le.caption[0]}
                        </div>

                        <UIInput maxLength="100" key="username" name="email" value={this.state.email} hint="email" onChange={this.dataChange} />
                        <UIInput key="password" type="password" name="password" value={this.state.password} onKeyUp={this.keyUp} hint="password" onChange={this.dataChange} />

                        <div className="widget-content-subtitle login-notes">{le.message}</div>

                        <UIButton className="confirm slim" text={le.caption[1]/*le.button*/} onClick={this.loginClick} />

                        <Link
                            className="forgot-password-link"
                            to="/forgot-password"
                        >
                            {le.forgotPassword}
                        </Link>

                        <div className="login-error">{this.state.modalMessage}</div>
                    </div>
                </div>
            </div>
        </div>;
        /*
        return (
            <div className="login container-fluid">
                <div className="row header">
                    <div className="col"><div className="login-logo" /></div>
                </div>
                <div className="row body">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <div className="orange-component" />
                                <h1>{le.caption[0]}</h1>
                                <h1 className="orange">{le.caption[1]}</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <InputBox item="email" data={{ type: 'input', text: 'email', value: this.state.email }} onChange={this.dataChange} />
                            </div>
                            <div className="col-9">
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <InputBox item="password" data={{ type: 'password', text: 'password', value: this.state.password }} onChange={this.dataChange} onKeyUp={this.keyUp} />
                            </div>
                            <div className="col-5">
                            </div>
                            <div className="col-4 right">
                                <p>{le.message}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-10">
                            </div>
                            <div className="col-2">
                                <UButton type="confirm" text={le.button} onClick={this.loginClick} />
                            </div>
                        </div>
                    </div>
                </div>
                {modalMsg}
            </div>
        );*/
    }
}
/*
export class Logout extends React.Component {
    componentDidMount() {
        sessionStorage.removeItem("userContext");
        ReactDOM.render(<Login />, document.getElementById('root'));
    }

    render() {
        return null;
    }
}
*/